import React, { useEffect, useState, Fragment } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 34,
    seconds: 2
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(219,234,254) 15%, rgb(254,232,232) 40%, rgb(254,232,232) 85%, rgb(255,255,255) 100%)'
  }} data-id="element-72">
      <div className="mx-auto max-w-4xl text-center" data-id="element-73">
        <h2 className="text-lg sm:text-xl font-black text-gray-900 m-0 mb-4" data-id="element-74">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-75">
          {[{
          value: timeLeft.hours,
          label: 'hs'
        }, {
          value: timeLeft.minutes,
          label: 'min'
        }, {
          value: timeLeft.seconds,
          label: 'seg'
        }].map((item, i) => <Fragment key={item.label} data-id="element-76">
              <div className="flex flex-col items-center" data-id="element-77">
                <span className="text-4xl sm:text-5xl font-black tabular-nums" style={{
              color: 'rgb(220,38,38)'
            }} data-id="element-78">
                  {pad(item.value)}
                </span>
                <span className="text-[10px] uppercase tracking-wide text-gray-400" data-id="element-79">
                  {item.label}
                </span>
              </div>
              {i < 2 && <span className="mb-4 text-4xl sm:text-5xl font-black" style={{
            color: 'rgb(220,38,38)'
          }} data-id="element-80">
                  :
                </span>}
            </Fragment>)}
        </div>

        <p className="font-bold text-gray-800 m-0 mb-5 text-[15px]" data-id="element-81">
          Después sube{' '}
          <span className="font-black text-red-600" data-id="element-82">$15.000 ARS</span> y no
          vuelve a bajar.
        </p>

        <div className="mx-auto max-w-xl" data-id="element-83">
          <div className="mb-1 flex items-center justify-between" data-id="element-84">
            <span className="text-xs font-bold text-red-500" data-id="element-85">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold text-gray-700" data-id="element-86">
              Quedan pocos
            </span>
          </div>
          <div className="h-2.5 w-full overflow-hidden rounded-full" style={{
          backgroundColor: 'rgb(254,226,226)'
        }} data-id="element-87">
            <div className="h-2.5 rounded-full" style={{
            width: '68%',
            background: 'linear-gradient(to right, rgb(239,68,68), rgb(252,165,165))'
          }} data-id="element-88" />
          </div>
          <p className="text-right text-[10px] text-gray-400 mt-1 mb-0" data-id="element-89">
            68% de los cupos tomados
          </p>
        </div>
      </div>
    </section>;
}